import { api } from './base';

import { TicketModel } from 'v2/types/TicketModel';

export const ticketService = {
  getTickets(): Promise<TicketModel[]> {
    return api.get('v1/admin/ticket').json();
  },

  getUnassignedTickets(): Promise<TicketModel[]> {
    return api.get('v1/admin/ticket/unassigned').json();
  },
};
